"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalizationModal = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fa_1 = require("react-icons/fa");
const react_2 = require("@headlessui/react");
const Button_1 = require("./Button");
const Input_1 = require("./Input");
const translations_1 = require("../i18n/translations");
function PersonalizationModal(_a) {
    var { className, font = 'Script', text, isOpen, onConfirm, parentLineId, onClose, locale = 'en' } = _a, props = __rest(_a, ["className", "font", "text", "isOpen", "onConfirm", "parentLineId", "onClose", "locale"]);
    const { personalizeModalTitle, personalizeFontStyleLabel, personalizeScriptLabel, personalizeBlockLabel, personalizeLine1Label, personalizeLine2Label, personalizeOptionalLabel, personalizeModalPriceNote, personalizeModalDisclaimerLabel, personalizeModalDisclaimerText, personalizeModalDisclaimerAgreeLabel, personalizeModalRequireLabel, personalizeModalConfirmButtonText, personalizeModalCloseButtonLabel, } = translations_1.personalizeContent[locale];
    const [isDisclaimerChecked, setIsDisclaimerChecked] = (0, react_1.useState)(false);
    const [selectedFont, setSelectedFont] = (0, react_1.useState)(font);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(true);
    const [line1, setLine1] = (0, react_1.useState)('');
    const [line2, setLine2] = (0, react_1.useState)('');
    const [line1Preview, setLine1Preview] = (0, react_1.useState)(line1);
    const [line2Preview, setLine2Preview] = (0, react_1.useState)(line2);
    const [errors, setErrors] = (0, react_1.useState)(['', '']);
    const ALLOWED_CHARACTERS_REGEX = /^[a-z0-9 áéíóúüñ.,:&;()~\-"']+$/i;
    const ALLOWED_CHARACTERS_ERROR = `Only alphanumeric characters, spaces and . , ( ) - " ' & ~ : ; Á É Í Ó Ú Ü Ñ á é í ó ú ü ñ are allowed.`;
    const text1 = (0, react_1.useRef)(null);
    const text2 = (0, react_1.useRef)(null);
    const updatePreview = (line1, line2) => {
        setLine1Preview(line1 || '');
        setLine2Preview(line2 || '');
    };
    (0, react_1.useEffect)(() => {
        const splitText = text.split('\n');
        const [line1, line2] = splitText;
        setLine1(line1 || '');
        setLine2(line2 || '');
        updatePreview(line1 || '', line2 || '');
    }, [text]);
    (0, react_1.useEffect)(() => {
        setSelectedFont(font || 'Script');
    }, [font]);
    const onTextChange = () => {
        const line1 = text1.current.value;
        const line2 = text2.current.value;
        updatePreview(line1 || '', line2 || '');
        const errors = ['', ''];
        if (ALLOWED_CHARACTERS_REGEX.test(line1) === false) {
            errors[0] = ALLOWED_CHARACTERS_ERROR;
        }
        if (line2.length > 0 && ALLOWED_CHARACTERS_REGEX.test(line2) === false) {
            errors[1] = ALLOWED_CHARACTERS_ERROR;
        }
        if (line1.length > 30) {
            errors[0] = 'Maximum 30 characters allowed';
        }
        if (line2.length > 30) {
            errors[1] = 'Maximum 30 characters allowed';
        }
        setErrors(errors);
    };
    const togglePersonalizationDisclaimer = (e) => {
        setIsDisclaimerChecked(e.target.checked);
    };
    const onSubmitButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        const line1Value = text1.current.value || '';
        const line2Value = text2.current.value || '';
        const text = [line1Value, line2Value].filter(String).join('\n');
        setIsLoading(true);
        setIsDisclaimerChecked(false);
        return onConfirm(parentLineId, text, selectedFont)
            .then(() => {
            setIsLoading(false);
            return { font: selectedFont, text };
        })
            .catch((error) => {
            setIsLoading(false);
            // bubble up the error
            throw error;
        });
    });
    const closeCallback = () => {
        setIsLoading(false);
        setIsDisclaimerChecked(false);
        onClose();
    };
    (0, react_1.useEffect)(() => {
        const hasErrors = errors.some((item) => !!item);
        setIsButtonDisabled(!isDisclaimerChecked || !line1Preview || isLoading || hasErrors);
    }, [isDisclaimerChecked, line1Preview, isLoading, errors]);
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)(` `, className) }, props),
        react_1.default.createElement(react_2.Transition, { show: isOpen, as: react_1.Fragment, unmount: true, static: true },
            react_1.default.createElement(react_2.Dialog, { static: true, onClose: closeCallback, className: "fixed z-1000 fixed top-0 bottom-0 right-0 left-0 overflow-hidden flex items-center justify-center p-4 text-gray", "aria-labelledby": react_2.Dialog.Title, "data-testid": "personalization-modal" },
                react_1.default.createElement(react_2.Transition.Child, { as: react_1.Fragment, enter: "ease-out duration-500", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-500", leaveFrom: "opacity-100", leaveTo: "opacity-0", static: true, unmount: true },
                    react_1.default.createElement(react_2.Dialog.Overlay, { className: "bg-black/30 fixed top-0 bottom-0 right-0 left-0" })),
                react_1.default.createElement(react_2.Transition.Child, { as: react_1.Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0 scale-95", enterTo: "opacity-100 scale-100", leave: "ease-in duration-300", leaveFrom: "opacity-100 scale-100", leaveTo: "opacity-0 scale-95", static: true, unmount: true },
                    react_1.default.createElement("div", { className: `bg-white rounded-2xl w-full max-w-[600px] duration-300 max-h-screen-95 mx-auto relative transition-all overflow-y-auto p-4 text-gray` },
                        react_1.default.createElement("div", { className: "relative" },
                            react_1.default.createElement(react_2.Dialog.Title, { className: "font-bold font-lg mb-4" }, personalizeModalTitle),
                            react_1.default.createElement("button", { className: "absolute -right-2 -top-2 p-2 transition-colors duration-300 text-gray-74 hover:text-gray", onClick: closeCallback, "aria-label": personalizeModalCloseButtonLabel },
                                react_1.default.createElement(fa_1.FaTimes, { className: "" }))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: "bg-blue-info text-blue-infotext rounded-md px-4 py-3 mb-4" },
                                react_1.default.createElement("p", null, personalizeModalPriceNote)),
                            react_1.default.createElement("div", { className: "text-sm font-bold mb-2" },
                                react_1.default.createElement("p", { className: "mb-2" },
                                    personalizeFontStyleLabel,
                                    ":"),
                                react_1.default.createElement("button", { className: (0, classnames_1.default)(`rounded-md inline-block px-2 py-1.5 border-2 font-bold font-helvetica uppercase mr-2`, selectedFont === 'Block'
                                        ? 'border-yellow'
                                        : 'border-gray-c'), onClick: () => setSelectedFont('Block'), tabIndex: 0 }, personalizeBlockLabel),
                                react_1.default.createElement("button", { className: (0, classnames_1.default)(`rounded-md inline-block px-2 py-1.5 border-2 font-bold font-script`, selectedFont === 'Script'
                                        ? 'border-yellow'
                                        : 'border-gray-c'), onClick: () => setSelectedFont('Script'), tabIndex: 0 }, personalizeScriptLabel)),
                            react_1.default.createElement("div", { className: "mb-2 -mx-2 flex flex-wrap" },
                                react_1.default.createElement("div", { className: "px-2 w-full sm:w-1/2" },
                                    react_1.default.createElement("div", { className: "text-sm mb-2" },
                                        react_1.default.createElement("label", { htmlFor: "personalization-line-1", className: "inline-block font-bold mb-1" }, personalizeLine1Label),
                                        react_1.default.createElement(Input_1.Input, { innerRef: text1, id: "personalization-line-1", type: "text", className: "w-full px-2 py-1", defaultValue: line1, onChange: onTextChange, "data-testid": "line-1-input" }),
                                        line1Preview.length > 0 ? (react_1.default.createElement("span", { style: { color: 'red' } }, errors[0])) : ('')),
                                    react_1.default.createElement("div", { className: "text-sm mb-2" },
                                        react_1.default.createElement("label", { htmlFor: "personalization-line-2", className: "inline-block font-bold mb-1" },
                                            personalizeLine2Label,
                                            " (",
                                            personalizeOptionalLabel,
                                            ")"),
                                        react_1.default.createElement(Input_1.Input, { innerRef: text2, id: "personalization-line-2", type: "text", className: "w-full px-2 py-1", defaultValue: line2, onChange: onTextChange, "data-testid": "line-2-input" }),
                                        line2Preview.length > 0 ? (react_1.default.createElement("span", { style: { color: 'red' } }, errors[1])) : (''))),
                                react_1.default.createElement("div", { className: "px-2 pb-2 w-full sm:w-1/2 self-end" },
                                    react_1.default.createElement("div", { className: `p-4 bg-gray-e font-bold ${selectedFont === 'Block'
                                            ? 'font-helvetica uppercase'
                                            : 'font-script'}` },
                                        react_1.default.createElement("p", { className: "" }, line1Preview),
                                        react_1.default.createElement("p", { className: "pt-2" }, line2Preview))))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: `border-t-1 border-gray-e text-sm mt-4 pt-4 overflow-hidden transition-all duration-200 ${isDisclaimerChecked
                                    ? 'max-h-0 opacity-0'
                                    : 'max-h-64 opacity-100'}` },
                                react_1.default.createElement("h3", { className: "font-bold" },
                                    personalizeModalDisclaimerLabel,
                                    ":"),
                                react_1.default.createElement("p", null, personalizeModalDisclaimerText)),
                            react_1.default.createElement("div", { className: "flex flex-wrap justify-between" },
                                react_1.default.createElement("div", { className: "relative w-full sm:w-auto mt-2" },
                                    react_1.default.createElement("label", { htmlFor: "personalization-discalimer", className: "font-bold text-sm relative" },
                                        react_1.default.createElement("input", { id: "personalization-discalimer", type: "checkbox", onChange: togglePersonalizationDisclaimer, className: "block rounded border border-borderColor inline-block mr-2", "data-testid": "disclaimer-check" }),
                                        personalizeModalDisclaimerAgreeLabel),
                                    react_1.default.createElement("p", { className: `text-xs mt-1 overflow-hidden transition-all duration-200 ${!isDisclaimerChecked
                                            ? 'max-h-32 opacity-100'
                                            : 'max-h-0 opacity-0'}` }, personalizeModalRequireLabel)),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("button", { "data-testid": "confirm-personalization", onClick: onSubmitButtonClick, className: (0, classnames_1.default)(`mt-2 ${Button_1.baseButtonStyles}`, Button_1.sizes['sm'], Button_1.variants['blue'].base, Button_1.variants.blue[isButtonDisabled ? 'disabled' : 'enabled']), disabled: isButtonDisabled }, personalizeModalConfirmButtonText))))))))));
}
exports.PersonalizationModal = PersonalizationModal;
